<template>
  <base-request-changes mode="reviewer"></base-request-changes>
</template>

<script>
import BaseRequestChanges from '@/components/base-components/BaseRequestChanges';

export default {
  components: {
    BaseRequestChanges
  }
};
</script>
